import * as React from 'react';
import FormEditingHandler from 'Containers/FormEditingHandler';
import Form from './Form';
import DocumentWrapper from 'Components/DocumentWrapper';
import DocumentHeader from 'Components/DocumentHeader';
import DiagnosticExamHistory from './History';

const getHeaderId = (editingDocType?: string) => {
  return editingDocType
    ? `polyneuroDiagnosticExams.${editingDocType ? `${editingDocType}` : ''}Title`
    : 'polyneuroDiagnosticExams.title';
};

const DiagnosticTests = ({ documents }: IOwnProps): React.JSX.Element => {
  const fileType = (editing: string) => documents.find(d => d._id === editing)?._type;

  return (
    <FormEditingHandler name="polyneuroDiagnosticExams" documents={documents}>
      {(editing, startEdit, formData): React.JSX.Element => {
        const editingDocType = documents.find(d => d._id === editing)?._type;
        return (
          <DocumentWrapper>
            <DocumentHeader
              name="polyneuroDiagnosticExams"
              headerId={getHeaderId(editingDocType)}
              editing={editing}
              editButtons={<div />}
            />
            {editing && fileType(editing) ? <Form formData={formData} type={fileType(editing)!} /> : null}
            {!editing ? <DiagnosticExamHistory documents={documents} startEdit={startEdit} /> : undefined}
          </DocumentWrapper>
        );
      }}
    </FormEditingHandler>
  );
};

interface IOwnProps {
  documents: (
    | IDocumentWithTypeV2<'csfExam'>
    | IDocumentWithTypeV2<'nerveBiopsy'>
    | IDocumentWithTypeV2<'skinBiopsy'>
  )[];
}

export default DiagnosticTests;
